/**
 * sanitize — XSS prevention utilities for LAUNCHER-2.0.
 *
 * sanitizeInput()   — strips HTML tags from user-generated text before
 *                     sending to the backend (plain-text sanitisation).
 * sanitizeHtml()    — cleans HTML content that will be rendered via
 *                     dangerouslySetInnerHTML using DOMPurify.
 */

import DOMPurify from 'dompurify';

/**
 * Strip all HTML/script tags from a plain-text user input string.
 * Preserves markdown formatting (**, *, `, etc.) since react-markdown
 * safely renders those without executing scripts.
 */
export function sanitizeInput(text) {
  if (typeof text !== 'string') return '';
  // Remove HTML tags but keep the inner text
  return text.replace(/<[^>]*>/g, '');
}

/**
 * Sanitize HTML intended for dangerouslySetInnerHTML rendering.
 * Allows safe SVG elements (needed for inline logos) but strips scripts,
 * event handlers, and other dangerous constructs.
 */
export function sanitizeHtml(html) {
  if (typeof html !== 'string') return '';
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true, svg: true },
    ADD_TAGS: ['svg', 'path', 'circle', 'rect', 'line', 'polyline', 'polygon', 'g', 'defs', 'use'],
    ADD_ATTR: ['viewBox', 'xmlns', 'd', 'fill', 'stroke', 'stroke-width', 'stroke-linecap', 'stroke-linejoin', 'cx', 'cy', 'r', 'x', 'y', 'rx', 'ry', 'width', 'height', 'transform', 'points'],
  });
}
